/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as UnauthorizedRouteImport } from './routes/Unauthorized'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AuthLicenseIssueRouteImport } from './routes/_auth.LicenseIssue'
import { Route as AuthFolderRouteRouteImport } from './routes/_auth.folder/route'
import { Route as AuthFolderIndexRouteImport } from './routes/_auth.folder/index'
import { Route as AuthFolderFolderIdRouteImport } from './routes/_auth.folder/$folderId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const UnauthorizedRoute = UnauthorizedRouteImport.update({
  id: '/Unauthorized',
  path: '/Unauthorized',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLicenseIssueRoute = AuthLicenseIssueRouteImport.update({
  id: '/LicenseIssue',
  path: '/LicenseIssue',
  getParentRoute: () => AuthRoute,
} as any)
const AuthFolderRouteRoute = AuthFolderRouteRouteImport.update({
  id: '/folder',
  path: '/folder',
  getParentRoute: () => AuthRoute,
} as any)
const AuthFolderIndexRoute = AuthFolderIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthFolderRouteRoute,
} as any)
const AuthFolderFolderIdRoute = AuthFolderFolderIdRouteImport.update({
  id: '/$folderId',
  path: '/$folderId',
  getParentRoute: () => AuthFolderRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/Unauthorized': typeof UnauthorizedRoute
  '/folder': typeof AuthFolderRouteRouteWithChildren
  '/LicenseIssue': typeof AuthLicenseIssueRoute
  '/folder/$folderId': typeof AuthFolderFolderIdRoute
  '/folder/': typeof AuthFolderIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/Unauthorized': typeof UnauthorizedRoute
  '/LicenseIssue': typeof AuthLicenseIssueRoute
  '/folder/$folderId': typeof AuthFolderFolderIdRoute
  '/folder': typeof AuthFolderIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/Unauthorized': typeof UnauthorizedRoute
  '/_auth': typeof AuthRouteWithChildren
  '/_auth/folder': typeof AuthFolderRouteRouteWithChildren
  '/_auth/LicenseIssue': typeof AuthLicenseIssueRoute
  '/_auth/folder/$folderId': typeof AuthFolderFolderIdRoute
  '/_auth/folder/': typeof AuthFolderIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/Unauthorized'
    | '/folder'
    | '/LicenseIssue'
    | '/folder/$folderId'
    | '/folder/'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/Unauthorized' | '/LicenseIssue' | '/folder/$folderId' | '/folder'
  id:
    | '__root__'
    | '/'
    | '/Unauthorized'
    | '/_auth'
    | '/_auth/folder'
    | '/_auth/LicenseIssue'
    | '/_auth/folder/$folderId'
    | '/_auth/folder/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  UnauthorizedRoute: typeof UnauthorizedRoute
  AuthRoute: typeof AuthRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/Unauthorized': {
      id: '/Unauthorized'
      path: '/Unauthorized'
      fullPath: '/Unauthorized'
      preLoaderRoute: typeof UnauthorizedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/LicenseIssue': {
      id: '/_auth/LicenseIssue'
      path: '/LicenseIssue'
      fullPath: '/LicenseIssue'
      preLoaderRoute: typeof AuthLicenseIssueRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/folder': {
      id: '/_auth/folder'
      path: '/folder'
      fullPath: '/folder'
      preLoaderRoute: typeof AuthFolderRouteRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/folder/': {
      id: '/_auth/folder/'
      path: '/'
      fullPath: '/folder/'
      preLoaderRoute: typeof AuthFolderIndexRouteImport
      parentRoute: typeof AuthFolderRouteRoute
    }
    '/_auth/folder/$folderId': {
      id: '/_auth/folder/$folderId'
      path: '/$folderId'
      fullPath: '/folder/$folderId'
      preLoaderRoute: typeof AuthFolderFolderIdRouteImport
      parentRoute: typeof AuthFolderRouteRoute
    }
  }
}

interface AuthFolderRouteRouteChildren {
  AuthFolderFolderIdRoute: typeof AuthFolderFolderIdRoute
  AuthFolderIndexRoute: typeof AuthFolderIndexRoute
}

const AuthFolderRouteRouteChildren: AuthFolderRouteRouteChildren = {
  AuthFolderFolderIdRoute: AuthFolderFolderIdRoute,
  AuthFolderIndexRoute: AuthFolderIndexRoute,
}

const AuthFolderRouteRouteWithChildren = AuthFolderRouteRoute._addFileChildren(
  AuthFolderRouteRouteChildren,
)

interface AuthRouteChildren {
  AuthFolderRouteRoute: typeof AuthFolderRouteRouteWithChildren
  AuthLicenseIssueRoute: typeof AuthLicenseIssueRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthFolderRouteRoute: AuthFolderRouteRouteWithChildren,
  AuthLicenseIssueRoute: AuthLicenseIssueRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  UnauthorizedRoute: UnauthorizedRoute,
  AuthRoute: AuthRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
